// extracted by mini-css-extract-plugin
export default {"section":"editUserData_section__Z72VC","btn":"editUserData_btn__sOSAm"};